import React from 'react';
import { KitPurchaseCard } from './KitPurchaseCard';
export function UpsellPurchase() {
  return <section className="w-full bg-[#fdfbf7] px-4 py-10 md:py-14" data-id="element-305" data-mp="3ox4ftazqmvqx">
      <KitPurchaseCard id="purchase" data-id="element-306" data-mp="3ous0l5ld6zhk" />
    </section>;
}